export function resolveIdsUrl(configuredIdsUrl: string, currentOrigin: string): string {
  return (configuredIdsUrl || currentOrigin).replace(/\/+$/, "");
}

const currentOrigin =
  typeof window === "undefined" ? "" : window.location.origin;

export class Settings {
  public static idsUrl = resolveIdsUrl(
    process.env.REACT_APP_IDS_URL,
    currentOrigin
  );
  public static defaultClient = "http://localhost:5002/home/about";
  public static redirectDelay = 12500;
  public static logoutRedirectDelay = 3000;
}
